import React from "react";
import { List } from "../modules/DelinquentBuyers";

export function DelinquentBuyersListPage() {
  return <List />;
}
